import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

@Pipe({
  name: 'dateGmt8'
})
export class DateGmt8Pipe implements PipeTransform {

  transform(value: any, format: string = 'DD/MM/YYYY hh:mm a'): string {
    if (!value) return '';

    // Assume value is a date string from API, parse as UTC
    const date = dayjs.utc(value);

    // Convert to GMT -8 (Pacific Time)
    const gmt8Date = date.tz('America/Los_Angeles');

    return gmt8Date.format(format);
  }

}
